import React, { Component, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './scss/style.scss';
import axios from 'axios';
import moment from 'moment';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

class App extends Component {

    constructor(props : any){
        super(props);
    }

    render() {
        return (
            <>
                <BrowserRouter>
                    <Suspense fallback={loading}>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/404" element={<Page404 />} />
                        <Route path="/500" element={<Page500 />} />
                        <Route path="*" element={<DefaultLayout />} />
                    </Routes>
                    </Suspense>
                </BrowserRouter>
                <ToastContainer />
            </>
        )
    }
}

export default App
